import TextareaWithEmoji from './TextareaWithEmoji';
export default TextareaWithEmoji;
